// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';
import { CATCHMENT_AREA_MAPS, getMediaByGallery } from '../../../../utils/keepeekUtils';
import KeepeekMedia from '../../../common/KeepeekMedia';
import type { MediaGallery } from '../../../../types/keepeekType';
import Loader from '../../../common/Loader';
import type { CentreTradeArea } from '../../../../types/marketingType';
import marketingApi from '../../../../network/api/marketingApi';
import type { ShoppingCenter } from '../../../../types/shoppingCenterType';
import { isUndefined } from '../../../../utils/utils';
import { getPrettifyValue, splitThousand } from '../../../../utils/formatUtils';
import NoElementFound from '../../../../components/NoElementFound';

type Props = {
  centreTradeArea: CentreTradeArea[],
  shoppingCenterMedia: MediaGallery[],
  isLoading: boolean,
}

const DISCOVERY_DASHBOARD_URL = 'https://dub01.online.tableau.com/#/site/urwtableau/views/CACI/Potentialofthecathmentarea';

class MarketingCatchmentArea extends React.Component<Props, State> {
  render() {
    if (this.props.isLoading) {
      return (
        <Loader isLoading />
      );
    }
    const { shoppingCenterMedia } = this.props;

    const catchmentAreaImage = getMediaByGallery(shoppingCenterMedia, CATCHMENT_AREA_MAPS)[0];
    if (!catchmentAreaImage || !shoppingCenterMedia || shoppingCenterMedia.length < 1) {
      return (
        <div className="loading-page">
          <NoElementFound text={<Translate value="MKT_PAGE.center_trade_area.NO_DATA" />}>
            <div key="key3" className="text">
              <Translate value="MKT_PAGE.center_trade_area.NO_DATA_ACTIONS" />
            </div>
          </NoElementFound>
        </div>
      );
    }
    return (
      <div className="marketing-catchment-area">
        <div className="centre-trade-area-tableau">
          <table>
            <thead>
              <tr>
                <th />
                <th>
                  <Translate value="MKT_PAGE.center_trade_area.centre_trade_area_tab.total_population" />
                </th>
                <th>
                  <Translate value="MKT_PAGE.center_trade_area.centre_trade_area_tab.total_retail_spend" />
                </th>
                <th>
                  <Translate value="MKT_PAGE.center_trade_area.centre_trade_area_tab.total_retail_spend_potential" />
                </th>
                <th>
                  <Translate value="MKT_PAGE.center_trade_area.centre_trade_area_tab.market_share" />
                </th>
              </tr>
            </thead>
            <tbody>
              {
              this.props.centreTradeArea
                .filter((centreTradeArea: CentreTradeArea) => centreTradeArea.tradeArea !== 'Residents')
                .sort((a, b) => a.order - b.order)
                .map((centreTradeArea: CentreTradeArea) => (
                  <tr
                    key={centreTradeArea.tradeArea}
                    className={(centreTradeArea.tradeArea.includes('Total')) ? 'total' : ''}
                  >
                    <td>
                      {centreTradeArea.tradeArea}
                    </td>
                    <td>
                      {isUndefined(centreTradeArea.population) ? '-' : splitThousand(centreTradeArea.population)}
                    </td>
                    <td>
                      {isUndefined(centreTradeArea.retailSpend) ? '-' : Number.parseFloat(centreTradeArea.retailSpend).toFixed(1)}
                    </td>
                    <td>
                      {Number.parseFloat(centreTradeArea.weightedRetailSpend).toFixed(1)}
                    </td>
                    <td>
                      {
                        centreTradeArea.marketShare
                          ? getPrettifyValue(
                          centreTradeArea.weightedRetailSpend / centreTradeArea.retailSpend,
                          1,
                          )
                          : '-'
                      }
                    </td>
                  </tr>
                ))
            }
            </tbody>
          </table>
        </div>
        <KeepeekMedia
          className="placeholder"
          keepeekMedia={catchmentAreaImage}
          href={DISCOVERY_DASHBOARD_URL}
          fullscreen
        />
      </div>
    );
  }
}

export default (MarketingCatchmentArea);
